// @ts-strict-ignore
import {Component, Input, OnInit} from "@angular/core";
import {SimDynamicScriptService} from "@services";

@Component({
	selector: "sim-dynamic-script",
	template: "",
	standalone: false,
})
export class DynamicScriptDirective implements OnInit {
	@Input() src: string;

	private resolver: (value?: PromiseLike<void> | void) => void;
	private rejecter: (reason?) => void;
	public readonly onResult: Promise<void> = new Promise<void>((resolve, reject) => {
		this.resolver = resolve;
		this.rejecter = reject;
	});

	constructor(private simDynamicScriptService: SimDynamicScriptService) {}

	ngOnInit(): void {
		this.simDynamicScriptService.loadScript(this.src).then(this.resolver, this.rejecter);
	}
}
